import React from "react";
import { useNavigate } from "react-router-dom";
import "./HeroS.css"; // CSS file for styling
import MOON from "./../../images/moon.jpg";
import Logo1 from "./../../images/mllogo1.png";

const MenuHero = () => {
  const navigate = useNavigate();

  const goToMenuList = () => {
window.scrollTo({ top: 0, behavior: "smooth" }); 
    navigate("/menulist"); // Navigate to `menulist` route
  };

  return (
    <div className="menu-hero-container">
      <div className="menu-hero-background-stars"></div>
      <div className="menu-shooting-star"></div>

      <div className="menu-hero-content">
        <div className="menu-hero-moon-container">
          <div className="menu-hero-moon-glow"></div>
          <div
            className="menu-hero-rotating-moon"
            style={{ backgroundImage: `url(${MOON})` }}
            alt="Moon Lounge Moon"
          ></div>
        </div>
        <img
          src={Logo1}
          alt="Moon Lounge Logo"
          className="menu-hero-image-logo"
        />
        <p className="menu-hero-text">
          Entdecke unsere exquisite Menükarte und genieße den Moment.
        </p>

        <button className="menu-hero-button" onClick={goToMenuList}>
          Menü Öffnen
        </button>
      </div>
    </div>
  );
};

export default MenuHero;
